import styled from "@emotion/styled";
import { rgba } from "emotion-rgba";
import { ThemeStyle } from "assets/scss/common/theme";

// Latest border button CSS as per new design system
export const BorderButton = styled.button<ThemeStyle>`
background-color: ${({ theme }: ThemeStyle) => theme.white};
border: 1px solid ${({ theme }: ThemeStyle) => rgba(theme.secondaryTextV1, 0.16)};
border-radius:${({ theme }: ThemeStyle) => theme.btnV1Radius};
font-weight: 600;
letter-spacing: 0.25px;
font-size: 16px;
cursor: pointer;

&.theme-text-color {
      color: ${({ theme }: ThemeStyle) => theme.brandPrimary};
}

&.grey-text-color {
  color: ${({ theme }: ThemeStyle) => rgba(theme.secondaryTextV1, 0.92)};
}

&.no-radius {
    border-radius: 0;
}

&.disabled,
&[disabled] {
  opacity: 0.36;
  }
}
`;

export const BasicButtonWithIcon = styled.button`
    border: none;
    cursor: pointer;
    font-weight: 600;
    text-align: center;
    padding: 8px 20px;
    background-color: ${({ theme }: ThemeStyle) => theme.transparent};
    letter-spacing: .4px;
`;
